var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowPvSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 7,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M6 6.95q-.201 0-.375-.063a.9.9 0 0 1-.325-.212L.675 2.05a.9.9 0 0 1-.262-.688A.98.98 0 0 1 .7.675.95.95 0 0 1 1.4.4q.424 0 .7.275l3.9 3.9L9.925.65a.9.9 0 0 1 .688-.263.98.98 0 0 1 .687.288.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-4.6 4.6q-.15.15-.325.212A1.1 1.1 0 0 1 6 6.95"
})));
export default SvgArrowPvSettings;